import { createFileRoute } from "@tanstack/react-router";
import { getHotelBySlug } from "../../data/data-layer";
import HeadManager from "../../services/HeadManager";
import HotelPage from "../../pages/HotelPage";

export const Route = createFileRoute("/hotels/$hotelId")({
  head: (ctx) => {
    return HeadManager.routerHead(ctx);
  },
  beforeLoad: async ({ params, context }) => {
    const data = await context.queryClient.fetchQuery(
      getHotelBySlug(params.hotelId),
    );
    const hotel = data?.data?.[0];
    return {
      title: hotel?.title,
      metadata: hotel?.metadata,
    };
  },
  loader: async ({ params, context: { queryClient } }) => {
    return {
      hotel: await queryClient
        .fetchQuery(getHotelBySlug(params.hotelId))
        .then((data) => data?.data?.[0]),
    };
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { hotel } = Route.useLoaderData();

  return <HotelPage hotel={hotel} />;
}
